import React from 'react';
import ScenarioContext, { IScenarioContext } from './context';

const useScenario = (): IScenarioContext => {
  const context = React.useContext(ScenarioContext);
  if (!context) {
    return {
      activeScenarioId: null,
      activeScenarioName: null,
      isSwitching: false,
      isResolvingScenario: false,
      switchTarget: null,
      setActiveScenario: () => {},
    };
  }
  return context;
};

export default useScenario;
